import { useEffect } from "react";

import { useBreakpointRange, constants } from "@newsela/angelou";
import PropTypes from "prop-types";

import useVideoEventBus from "@/view/utils/useVideoEventBus";
import useCurrentArticleLevelId from "@/view/utils/useCurrentArticleLevelId";
import getEventPropertiesContentType from "@/view/utils/getEventPropertiesContentType";
import videoPlayerEvents from "@/view/constants/videoPlayerEvents";
import ActivityHeader from "../ActivityHeader";
import { headingCss } from "../ActivityHeader/ActivityHeader.style";
import contentTypes from "../constants/contentTypes";
import PanelHeader from "../PanelHeader";
import VideoQuizQuestions from "../VideoQuizQuestions";
const { zeroToXs } = constants.breakpoints.BreakpointRanges;

const propTypes = {
  closeButtonEventProperties: PropTypes.object,
  activeVideoActivityLabel: PropTypes.string,
  onClickCloseButton: PropTypes.func,
  setActiveVideoActivityLabel: PropTypes.func,
  shouldFocusCloseButtonRef: PropTypes.object,
  isStudent: PropTypes.bool,
};

const VideoActivityContainer = ({
  closeButtonEventProperties,
  activeVideoActivityLabel,
  onClickCloseButton,
  setActiveVideoActivityLabel,
  shouldFocusCloseButtonRef,
  isStudent,
}) => {
  const levelId = useCurrentArticleLevelId();

  const contentType = contentTypes.INTERACTIVE_VIDEO;

  const backButtonEventProperties = {
    objectType: "Quiz",
    actionName: "Navigate",
    streamProperties: {
      content_type: getEventPropertiesContentType(contentType),
      description: "Navigate back to Activity Picker from quiz question",
      content_id: levelId,
    },
  };

  const breakpointRange = useBreakpointRange();
  const { VIEW_PAGE_EVENT } = videoPlayerEvents;
  const { sendVideoPlayerEvent } = useVideoEventBus();

  const isExtraSmall = breakpointRange === zeroToXs;

  useEffect(() => {
    sendVideoPlayerEvent(VIEW_PAGE_EVENT.RESET_ACTIVITY_PANEL_CONTENTS);
  }, [isExtraSmall]);

  const renderHeaderText = () => {
    return activeVideoActivityLabel ? (
      <h2 css={headingCss}>{activeVideoActivityLabel}</h2>
    ) : (
      <ActivityHeader isArticle={false} isStudent={isStudent} />
    );
  };
  return (
    <>
      <PanelHeader
        backButtonEventProperties={backButtonEventProperties}
        closeButtonEventProperties={closeButtonEventProperties}
        contentType={contentType}
        onClickCloseButton={onClickCloseButton}
        setActiveVideoActivityLabel={setActiveVideoActivityLabel}
        shouldFocusCloseButtonRef={shouldFocusCloseButtonRef}
        videoQuizIsActive={!!activeVideoActivityLabel}
      >
        {renderHeaderText()}
      </PanelHeader>
      <VideoQuizQuestions />
    </>
  );
};

VideoActivityContainer.propTypes = propTypes;

export default VideoActivityContainer;
